module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "block"
  }, [_c('el-timeline', _vm._l((_vm.records), function(item) {
    return _c('el-timeline-item', {
      key: item.id,
      attrs: {
        "timestamp": item.time,
        "placement": "top"
      }
    }, [_c('el-card', [_c('h3', [_vm._v(_vm._s(item.version))]), _vm._v(" "), _vm._l((item.arr), function(itemArr) {
      return _c('p', {
        key: itemArr
      }, [_vm._v(_vm._s(itemArr))])
    })], 2)], 1)
  }), 1)], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/.store/vue-loader@11.3.4/~/vue-loader/lib/template-compiler?{"id":"data-v-7968a39a"}!./~/.store/vue-loader@11.3.4/~/vue-loader/lib/selector.js?type=template&index=0!./src/views/sysManage/VersionHistory.vue
// module id = 1946
// module chunks = 1